<template>
  <section class="address">
    <div class="address__header">
      <Header type="h4" spaced>
        <!-- <template v-slot:title>Настроить связку СКУД-сервера с адресом</template> -->
        <template v-slot:addons v-if="removable">
          <span @click="$emit('remove')" class="address__header-remove">
            <icon-base icon-name="minus-outlined" label="Убрать адрес" />
          </span>
        </template>
      </Header>
    </div>
    <div class="address__form">
      <FormList
        v-model="formValue"
        :list="extendedFormList"
        flex-row
        @listServerAdd="listServerAdd"
      />
    </div>
    <!-- <div class="address__file">
      <FormFile v-model="fileValue" label="Загрузить файл с абонентами" />
    </div> -->
    <div
      v-if="form.server && form.server.length"
      class="d-flex justify-content-end align-items-center pt-3 address__status"
    >
      <Chips v-if="chips.length" :chips="chips" />
      <span v-if="checkedAt" class="address__checked-at">
        Проверено: {{ checkedAt }}
      </span>
    </div>
  </section>
</template>

<script>
import FormList from '../../components/Form/List.vue'
// import FormFile from "../../components/Form/File.vue";
import Chips from '../../components/Chips.vue'
import Header from '../../components/Header.vue'
import IconBase from '../../components/Icons/IconBase.vue'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  name: 'Address',
  mixins: [ServiceData],
  components: { Header, FormList, IconBase, Chips },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    // file: {
    //   type: File,
    //   default: () => {},
    // },
    index: {
      type: Number,
      default: 1,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    formList: {
      type: Object,
      default: () => {},
    },
    serverList: {
      type: Array,
      default: () => [],
    },
    issuerOptions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    extendedFormList() {
      if (!this.selectedServerIsBle) return this.formList
      return [
        ...this.formList,
        {
          id: 'issuer_id',
          label: 'Эмитент BLE',
          required: true,
          type: 'select',
          width: 5,
          attr: {
            placeholder: 'Выберите эмитента',
            options: this.issuerOptions,
          },
        },
      ]
    },
    selectedServerIsBle() {
      const serverId = this.form.server
      if (!serverId) return false
      const server = this.serverList.find(s => s.suid === serverId)
      return server?.type?.is_ble === true
    },
    selectedServerSuid() {
      const serverId = this.form.server
      if (!serverId) return null
      if (Array.isArray(serverId)) return serverId.length ? serverId[0] : null
      return serverId
    },
    serverHealth() {
      const suid = this.selectedServerSuid
      if (!suid) return null
      return this.serverHealthChecks[suid] || null
    },
    chips() {
      const h = this.serverHealth
      if (!h) return []
      return [
        h.is_online
          ? {
              id: 'srvrwrks',
              type: 'complited',
              icon: 'check',
              label: 'Сервер работает',
            }
          : {
              id: 'srvrerr',
              type: 'failed',
              icon: 'cross',
              label: 'Сервер не работает',
            },
      ]
    },
    checkedAt() {
      const h = this.serverHealth
      return h?.last_health_check_at
        ? this.$moment(h.last_health_check_at).format('DD.MM.YYYY HH:mm')
        : null
    },
    formValue: {
      get() {
        return {
          ...this.form,
        }
      },
      set(value) {
        const newValue = { ...value }
        const serverId = newValue.server
        const server = serverId
          ? this.serverList.find(s => s.suid === serverId)
          : null
        if (!server?.type?.is_ble) {
          newValue.issuer_id = null
        }
        this.$emit('update:form', newValue)
        this.$emit('change', newValue)
      },
    },
    // fileValue: {
    //   get() {
    //     return this.file;
    //   },
    //   set(value) {
    //     this.$emit("update:file", value);
    //   },
    // },
  },
  watch: {
    selectedServerSuid: {
      immediate: true,
      handler(suid) {
        if (suid && !this.serverHealthChecks[suid]) {
          this.getServerHealthCheck(suid)
        }
      },
    },
  },
  methods: {
    listServerAdd() {
      this.$emit('listServerAdd')
    },
  },
}
</script>

<style lang="scss" scoped>
.address {
  display: flex;
  flex-direction: column;
  // gap: $space-xmd;
  margin: $space-lg $space-md;
  padding: 50px 24px;
  border: 1px dashed $add-intercom-addres-border-color;
  border-radius: $border-radius-lg;

  &__header {
    &-remove {
      cursor: pointer;
    }
  }

  &__status {
    gap: $space-xxs;
  }

  &__checked-at {
    font-size: 14px;
    line-height: 20px;
    color: $color-grey;
  }
}
</style>
